import { render, staticRenderFns } from "./ContactFormular.vue?vue&type=template&id=30c028a0&scoped=true"
import script from "./ContactFormular.vue?vue&type=script&lang=js"
export * from "./ContactFormular.vue?vue&type=script&lang=js"
import style0 from "./ContactFormular.vue?vue&type=style&index=0&id=30c028a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c028a0",
  null
  
)

export default component.exports